import './sendImage.scss';

export const SendImageTemplate = (model) => {
	const { imageUrl, altText, id, messageText, showText = false } = model;

	const text =
		messageText && showText
			? `
    <div class="engt-msg-image-text">
            ${messageText}
    </div>
    `
			: '';

	/* html */
	const html = `
        <img
            class="engt-msg-image-view"
            tabindex="0"
            onkeydown="ENGT_CHAT.onEnterPress()"
            style="cursor: pointer;"
            id="engtImage-${id}"
            src="${imageUrl}"
            alt="${altText}"
            width="100%"
            height="100%"
            loader="lazy" />
        ${text}
    `;

	return html;
};
